export default "__VITE_ASSET__95506c50__"